var _defs, _rect, _circle, _rect2, _text, _text2, _rect3, _rect4, _rect5, _text3, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverWarrantyService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Warranty and service management",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0b1220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1e293b"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1010,
    cy: 140,
    r: 190,
    fill: "#f59e0b",
    opacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 110,
    width: 1020,
    height: 540,
    rx: 30,
    fill: "#111827",
    stroke: "#f97316",
    strokeOpacity: 0.4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 210,
    fill: "#f8fafc",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 44,
    fontWeight: 800
  }, "WARRANTY PLATFORM")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 250,
    fill: "#cbd5e1",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 24
  }, "Claim lifecycle, QR lookup, retailer workflow")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 322,
    width: 220,
    height: 220,
    rx: 16,
    fill: "#f97316",
    opacity: 0.92
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 392,
    width: 80,
    height: 80,
    fill: "#111827"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 322,
    width: 610,
    height: 220,
    rx: 16,
    fill: "#0f172a",
    stroke: "#475569"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 388,
    fill: "#f8fafc",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "NestJS  TypeScript  MySQL")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 430,
    fill: "#cbd5e1",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 20
  }, "JWT  Swagger  Jenkins  Docker")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverWarrantyService);
export default __webpack_public_path__ + "static/media/cover-warranty-service.87204e570b1da43cd40e9e0735e3a9ea.svg";
export { ForwardRef as ReactComponent };